import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { Utils, NumberFormatter, domainVal, DateFormatter, i18n } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import BisogniActions from './bisogni_actions';
import Bisogno from './bisogno.jsx';
import { AppConstants } from '../../constants/AppConstants';
import { isNullOrUndefined } from 'util';

class BisogniList extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[BisogniList.jsx] ';
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //effettuo la chimata rest per recuperare i dati
        this.props.getListBisogni();
    }


    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');


    }


    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card">
                <div className="card-header">
                    <h3>{i18n('ARM_CORE_PRODUCT.BISOGNO.LISTA_BISOGNI_E_GRUPPI', 'Lista Bisogni / Micro-categorie / Prodotti')}</h3>
                </div>
                <div className="card-body">

                    {this.props.bisogni.map((bisogno, index) =>
                        <Bisogno
                            key={'B' + index}
                            bisogno={bisogno}
                            indexBisogno={index}
                        />
                    )
                    }


                </div>
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getListBisogni() {
            return dispatch(BisogniActions.getListBisogni());
        },
    }
};

function mapStateToProps(state) {
    return {
        bisogni: state.bisogni.listaBisogni
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(BisogniList);
